import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { MarigoldMark } from "@/components/Logo";
import { SITE } from "@/constants/site";

const links = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 border-b border-ink/10 bg-cream"
        >
            <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
                <Link
                    to="/"
                    data-testid="nav-logo-link"
                    className="flex items-center gap-3"
                >
                    <MarigoldMark className="h-8 w-8 text-gold" />
                    <span className="font-serif text-2xl font-medium tracking-tight">
                        Phillip
                        <span className="ml-2 align-middle font-mono text-[10px] uppercase tracking-[0.25em] text-clay">
                            CPA
                        </span>
                    </span>
                </Link>

                <nav className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <NavLink
                            key={l.path}
                            to={l.path}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-sm font-medium transition-colors ${
                                    isActive
                                        ? "text-gold-deep"
                                        : "text-ink hover:text-gold-deep"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href={SITE.phoneHref}
                        data-testid="nav-cta-phone"
                        className="flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:bg-gold-deep"
                    >
                        <Phone className="h-3.5 w-3.5" />
                        {SITE.phoneDisplay}
                    </a>
                </nav>

                <button
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-ink/15 md:hidden"
                    data-testid="mobile-menu-btn"
                    aria-label="Toggle menu"
                    onClick={() => setOpen((v) => !v)}
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            {open && (
                <nav
                    className="border-t border-ink/10 bg-cream md:hidden"
                    data-testid="mobile-menu"
                >
                    <div className="flex flex-col gap-1 px-4 py-4">
                        {links.map((l) => (
                            <NavLink
                                key={l.path}
                                to={l.path}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `rounded-xl px-4 py-3 font-serif text-2xl ${
                                        isActive ? "text-gold-deep" : "text-ink"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href={SITE.phoneHref}
                            data-testid="mobile-nav-cta-phone"
                            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-ink px-5 py-3 text-sm font-semibold text-cream"
                        >
                            <Phone className="h-4 w-4" />
                            Call {SITE.phoneDisplay}
                        </a>
                    </div>
                </nav>
            )}
        </header>
    );
}
